import{jsx as e}from"react/jsx-runtime";import t,{css as r}from"styled-components";import{Fonts as n}from"../../fonts/index.js";const i=t.sup.withConfig({displayName:"StyledSuper",componentId:"VDS__sc-11t8v6m-0"})`
  vertical-align: text-top;

  ${function({$feature:e,$superscriptSmall:t}){return e&&t&&r`
      font-size: 50%;
      font-family: ${n.VerizonNHGeDS};
    `}};
  ${function({$superscriptSmall:e}){return!e&&r`
      line-height: normal;
    `}};
`,o=function(t){const{children:r,superscriptSmall:n,feature:o,"data-testid":s}=t,a={0:"⁰",1:"¹",2:"²",3:"³",4:"⁴",5:"⁵",6:"⁶",7:"⁷",8:"⁸",9:"⁹"};return"string"!=typeof r&&"number"!=typeof r?(console.warn("Super element only allows children of type string or number."),null):e(i,Object.assign({},n&&{$feature:o,$superscriptSmall:n},{"data-testid":s,children:r&&(l=r,[...l].map((function(e){return Number.isNaN(Number(e))?e:a[e]})))}));var l};o.displayName="Super";export{o as default};
